import axios from "axios";
import { httpService } from "./api/Api";

export const getSurveyList = () => {
    return httpService.get('Generic/GetSurveys');
}

export const SaveSurveyDetails = (obj: any) => {
    return httpService.post('Generic/SaveSurveyDetails', obj);
}